module.exports = __webpack_public_path__ + "static/media/csv-preview-classes.0a69e98b.jpg";